import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (refresh) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/factory/area',
    name: 'factoryLocationGet',
    method: 'GET'
  });
  useEffect(() => {
    if (refresh) {
      exec({ url: '/api/factory/area' })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  return [isRequestSuccessed, data || [], exec];
})
